module.exports = __webpack_public_path__ + "img/emo_02.05dcc290.png";